module.exports = __webpack_public_path__ + "images/mr-xxxmas-9a260a722828d42f1a649d7d1b0c41c2.png";